import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Badge, Nav, NavItem, NavLink as RsNavLink } from 'reactstrap'
import classNames from 'classnames'
import nav from './_nav'
import SidebarFooter from './../SidebarFooter'
import SidebarForm from './../SidebarForm'
import SidebarHeader from './../SidebarHeader'
import SidebarMinimizer from './../SidebarMinimizer'
import * as userSession from '../../services/session'
import { connect } from 'react-redux'
import * as pageService from '../../services/page'
import { navItem } from "./navItem";
import { navLink } from "./navLink";
import { renderSidebar } from "./renderSidebar";

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navsInfo: {}
    }

    this.load = this.load.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.activeRoute = this.activeRoute.bind(this)
    this.hideMobile = this.hideMobile.bind(this)
  }

  componentWillMount() {
    this.setState({ navsInfo: nav })
    this.load()
  }

  load(state, instance) {
    return pageService.nav(state).then(data => {
      const navs = this.state.navsInfo
      navs.items[1].children = []
      data['hydra:member'].map(el => {
        const { title, ...updatedEl } = el
        updatedEl.name = el.title
        updatedEl.url = '/page/' + el.id
        navs.items[1].children.push(updatedEl)
      })

      navs.items[1].children.sort((a, b) => {
        return parseInt(a.menuScore) - parseInt(b.menuScore)
      })

      this.setState({ data: [] }, () => {
        this.setState({
          navsInfo: navs
        })
      })
    })
  }

  handleClick(e) {
    e.preventDefault()
    e.target.parentElement.classList.toggle('open')
  }

  activeRoute(routeName, props) {
    // return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown'
  }

  hideMobile() {
    if (document.body.classList.contains('sidebar-mobile-show')) {
      document.body.classList.toggle('sidebar-mobile-show')
    }
  }

  // todo Sidebar nav secondLevel
  secondLevelActive(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1
      ? 'nav nav-second-level collapse in'
      : 'nav nav-second-level collapse'
  }

  render() {
    const props = this.props



    // simple wrapper for nav-title item
    const wrapper = (item, key, classes) => {
      const url = '#/page/' + item.id

      const currentUser = userSession.getUser()

      let put = false

      if (item.seller && userSession.testRole('ROLE_TCP')) put = true

      if (item.seller && userSession.testRole('ROLE_ADV')) put = true

      if (item.buyer && userSession.testRole('ROLE_USER')) put = true

      //Ici il il y a collect, mais que le costumer n'a pas fournisseur, alors on afiche pas

      if (put) {
        return (
          <NavItem key={key} className={classes.item}>
            <RsNavLink
              href={url}
              className={classes.link}
              active={false}
              onClick={() => {
                this.hideMobile()
                window.location.reload()
              }}
            >
              <i className={classes.icon}></i>
              {item.title}
              {badge(item.badge)}
            </RsNavLink>
          </NavItem>
        )
      }
    }

    // nav list section title
    const title = (item, key) => {
      const classes = {
        item: classNames(item.class),
        link: classNames('nav-link', item.variant ? `nav-link-${item.variant}` : ''),
        icon: classNames(item.icon)
      }
      return wrapper(item, key, classes)
    }

    // nav list divider
    const divider = (divider, key) => {
      const classes = classNames('divider', divider.class)
      return <li key={key} className={classes}></li>
    }

    // nav label with nav link
    const navLabel = (item, key) => {
      const classes = {
        item: classNames('hidden-cn', item.class),
        link: classNames('nav-label', item.class ? item.class : ''),
        icon: classNames(
          !item.icon ? 'fa fa-circle' : item.icon,
          item.label.variant ? `text-${item.label.variant}` : '',
          item.label.class ? item.label.class : ''
        )
      }
      return navLink(item, key, classes)
    }


    // nav dropdown
    const navDropdown = (item, key) => {
      let put = true

      if (item.roles && !userSession.testRole(item.roles)) put = false

      if (item.costumer && !this.props.user.organisation) put = false

      if (item.collect === true && this.props.user.organisation && !this.props.user.organisation.isProvider) put = false

      if (put) {
        return (
          <li key={key} className={this.activeRoute(item.url, props)}>
            <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick}>
              <i className={item.icon}></i>
              {item.name}
            </a>
            <ul className="nav-dropdown-items">{navList(item.children)}</ul>
          </li>
        )
      }
    }


    // nav type
    const navType = (item, idx) =>
      item.title
        ? title(item, idx)
        : item.divider
          ? divider(item, idx)
          : item.label
            ? navLabel(item, idx)
            : item.children
              ? navDropdown(item, idx)
              : navItem(item, idx)

    // nav list
    const navList = items => {
      return items.map((item, index) => navType(item, index))
    }

    // sidebar-nav root

    return renderSidebar(this.props, this.state, navList)
  }
}

const mapStateToProps = state => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({})

module.exports = connect(mapStateToProps, mapDispatchToProps)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js